// This icon file is generated automatically.
var ResizeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M190.12 158.91h211.53a22.07 22.07 0 100-44.13h-264.8a22.15 22.15 0 00-22.08 22.07v264.82a22.08 22.08 0 0044.14.01V190.12l271.25 271.27a22.08 22.08 0 0031.24-31.22L190.12 158.9zm719.11 463.42a22.06 22.06 0 00-22.06-22.06 22.06 22.06 0 00-22.08 22.05v211.56l-271.27-271.3a22.13 22.13 0 00-31.23 0 22.13 22.13 0 000 31.24l271.3 271.25H622.33a22.07 22.07 0 00-.02 44.15h264.84a22.15 22.15 0 0022.06-22.07V622.33z" } }] }, "name": "resize", "theme": "outlined" };
export default ResizeOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/ResizeOutlined.js
// module id = 3998
// module chunks = 0